{
    "Profile_Drivers_Suspension.drivingSuspension": "Driving Suspension",
    "Profile_Drivers_Suspension.drivingSuspensionDetails": "Driving Suspension Details",
    "Profile_Drivers_Suspension.startDate": "Start Date",
    "Profile_Drivers_Suspension.endDate": "End Date",
    "Profile_Drivers_Suspension.reinstatementDate": "Reinstatement Date",
    "Profile_Drivers_Suspension.relatedConviction": "Related Conviction"
}
